module.exports = __webpack_public_path__ + "img/icon28.7ac6a605.png";